import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'manager/scheduleassign/list',
  urlRoot: 'manager/scheduleassign/list',

  state: {
    total: 0
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  },

  actions: {
    confirm(context, assign) {
      http.patch('manager/scheduleassign/' + assign.item.id + '/done')
    },
    cancel(context, assign) {
      http.patch('manager/scheduleassign/' + assign.item.id + '/canceled')
    }
  }
})

export default withDataFilter(store)
